import * as React from 'react';
import { useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';

import { Comment, CommentPart } from '../../../components/Comment';
import { getReviewById } from '../../../selectors/reviews';

interface IAuthorContainerProps {
  reviewId: string;
}

export function CommentContainer({ reviewId }: IAuthorContainerProps) {
  const { comment, labels, isLegacy } = useSelector(getReviewById(reviewId));
  const isMobile = useDeviceType() !== 'desktop';

  return (
    <Comment title={comment.type} label={labels[0]} isLegacy={isLegacy} isMobile={isMobile}>
      {isLegacy ? (
        <CommentPart message={comment.legacy} />
      ) : (
        <>
          <CommentPart title="Плюсы:" message={comment.positive} />
          <CommentPart title="Минусы:" message={comment.negative} />
        </>
      )}
    </Comment>
  );
}
